<template>
  <div id="app" class="bg">
    <router-view></router-view>
  </div>
</template>

<script>
import Home from './components/Home.vue'
import ThankYou from './components/ThankYou.vue'

export default {
  name: 'app',
  components: {
    'Home': Home,
    'ThankYou': ThankYou
  }
}
</script>

<style>
.bg {
    background-image: url("./assets/jefferson.jpg");
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue